import { useParams } from 'react-router-dom';
import { useDocumentTitle } from '../lib/useDocumentTitle';
import { useInjectedMeta } from '../lib/useInjectedMeta';
import { AppCta } from '../components/AppCta';
import { milestoneAppLink } from '../lib/appLinks';

/**
 * Public milestone share landing — `/s/:code/m/:messageId`. The PB hook
 * share_milestone_html.pb.js serves the OG tags for crawlers; this component
 * renders the human-facing page after the SPA hydrates.
 *
 * The milestone headline is read back out of the injected `<head>` rather than
 * fetched: the hook has already resolved and authorised it (messages are
 * crew-gated, so there is no anonymous endpoint to call), and it is sitting in
 * the document the browser just parsed. No request, no auth, no new surface.
 */
export function MilestoneShare() {
  const { code, messageId } = useParams<{ code: string; messageId: string }>();
  const headline = useInjectedMeta('og:title');

  useDocumentTitle(headline || 'A milestone on Skiffs');

  const deepLink = milestoneAppLink(code, messageId);

  return (
    <article className="skf-card">
      <h1 className="skf-title">A milestone, reached.</h1>
      <p className="skf-subtitle">{headline ?? 'Someone on Skiffs just hit a milestone.'}</p>
      <AppCta deepLink={deepLink} />
    </article>
  );
}
